import { motion } from "framer-motion";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import { useLayoutStore } from "../../context";
import { TrophyIcon, ChartBarIcon, SparklesIcon, ArrowUturnRightIcon, CurrencyDollarIcon, WrenchIcon } from "@heroicons/react/24/outline";
import constants from "../../utils/constants";

function NavItem({ item, navigate }) {
  return (
    <li
      className="cursor-pointer rounded-md w-full my-2 p-3 border font-semibold text-[#96c6c9] border-[#96c6c9] hover:bg-[#96c6c9] hover:text-white"
      onClick={() => (item && item.path ? navigate(item.path) : {})}
    >
      <item.icon className="h-8 w-8 cursor-pointer float-left me-2" />
      {item.label}
    </li>
  );
}

export default function SideNavMenu() {
  const isSidebarOpen = useLayoutStore((state) => state.isSidebarOpen);
  const navigate = useNavigate();
  const paths = constants.ROUTE_PATHS;
  const navItems = [
    { label: "Dashboard", path: "/", icon: ChartBarIcon },
    { label: "On Tap", path: paths.ON_TAP, icon: SparklesIcon },
    { label: "On Deck",path: paths.ON_DECK , icon: ArrowUturnRightIcon },
    { label: "Bottles/Cans", icon: TrophyIcon },
    { label: "Orders", icon: CurrencyDollarIcon },
    { label: "Management", path: paths.MANAGEMENT, icon: WrenchIcon },
    { label: "System Admin", path: paths.SYS_ADMIN, icon: WrenchIcon }
  ];

  return (
    <motion.div
      animate={{
        x: isSidebarOpen ? 0 : "-100%",
      }}
      initial={{ x: "-100%" }}
      exit={{ x: "-100%" }}
      transition={{ type: "spring", stiffness: 95, damping: 20 }}
      style={{
        position: "fixed",
        top: "4rem",
        display: "flex",
        flexDirection: "column",
        float: "left",
        width: "16rem",
        height: "calc(100vh - 4rem)",
        overflowY: "auto",
        borderRight: "2px solid #e5e5e5",
        alignItems: "center",
        overflowX: "hidden",
        zIndex: 50,
      }}
    >
      <nav
        className="flex w-full h-full px-2 justify-center bg-[#403e41] overflow-y-auto overflow-x-hidden"
        aria-label="sidebar"
      >
        <ul className="w-full">
          {_.map(navItems, (item) => (
            <NavItem key={item.label} item={item} navigate={navigate} />
          ))}
        </ul>
      </nav>
    </motion.div>
  );
}
